var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-border-l"},[_c('gl-button',{staticClass:"gl-mx-3",attrs:{"aria-label":_vm.s__('DesignManagement|Go back to designs'),"data-testid":"close-design","icon":"close","category":"tertiary","to":{
      name: _vm.$options.ROUTES.workItem,
      query: _vm.$route.query,
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }